import UsersPermissionsContainer from "../../../features/user/UsersPermissionsContainer";
import { anyPermission, hasPermission, PermissionId, STUDENT_PERMISSIONS } from "../../../app/permissions";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/user/userSlice";

interface StudentUsersListProps {
  schoolId: string;
  classroomId?: string;
  studentId: string;
}

const StudentUsersList = ({ schoolId, classroomId, studentId }: StudentUsersListProps) => {
    const user = useSelector(selectUser);
    const perm: boolean = 
        hasPermission(user.priza.info, PermissionId.SCHOOL_ADMIN, schoolId)
        || (classroomId != undefined && anyPermission(user.priza.info, classroomId, [ PermissionId.CLASSROOM_ADMIN, PermissionId.CLASSROOM_TEACHER ]))
        || anyPermission(user.priza.info, studentId, [ PermissionId.STUDENT_ADMIN, PermissionId.STUDENT_PARENT ])
    ;
    return <UsersPermissionsContainer
        canGrantPermission={perm}
        targetId={studentId}
        permissions={STUDENT_PERMISSIONS}
        messages={{
        title: "Pais e Responsáveis",
        empty: "Ninguém associado a este aluno.",
        }}
    />;
};

export default StudentUsersList;